import type { RoundCurrent } from "../types/api";

// Pure reconciliation rule for the OBJETIVOS selector (event hardening
// P2/P5, multi-target LIVE round): preserve the current selection while
// it's still part of the LIVE round, otherwise fall back to the round's
// first target. With no LIVE round (or a LIVE round with no targets — the
// gap between round.closed and the next round.started), the selection is
// left untouched: it's the caller's job to decide what "no active round"
// should show for whatever was last selected (see AimPortal.tsx's
// noActiveRound, driven by that target's own roundStatus).
export function reconcileTargetSelection(current: RoundCurrent, selectedTargetId: string): string {
  if (current.status !== "LIVE" || current.targets.length === 0) return selectedTargetId;
  const stillLive = current.targets.some((t) => t.targetId === selectedTargetId);
  return stillLive ? selectedTargetId : current.targets[0].targetId;
}
